const initialState = {}

export const sidebarReducer = (state = initialState, action: any) => {
    return state;
}